import { useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { EmployeeTemplate } from '../../../types/EmployeeTemplate';

export const fetchEmployeeTemplate = async (uuid: string | undefined) => {
  if (!uuid) return null;

  const response = await CustomAxios.get<EmployeeTemplate>(`employee_templates/${uuid}`);
  return response.data;
};

interface UseGetEmployeeTemplateByIdProps {
  uuid?: string;
}

export function useGetEmployeeTemplateById({ uuid }: UseGetEmployeeTemplateByIdProps) {
  return useQuery({
    queryKey: [queryKeys.allEmployeeTemplates, uuid],
    queryFn: () => fetchEmployeeTemplate(uuid),
  });
}
